import { mediaQueries } from "../../styles/mediaQueries";

export const desktopMediaQuery = mediaQueries.isDesktopScene;